require("./Promise");
require("./FormData");
export const polyfill = {
	//JSON
	JSON: {
		parse: function (sJSON) {
			return eval("(" + sJSON + ")");
		},
		stringify: (function () {
			var toString = Object.prototype.toString;
			var isArray = Array.isArray || function (a) {
				return toString.call(a) === "[object Array]";
			};
			var escMap = {"\"": "\\\"", "\\": "\\\\", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t"};
			var escFunc = function (m) {
				return escMap[m] || "\\u" + (m.charCodeAt(0) + 0x10000).toString(16).substr(1);
			};
			var escRE = /[\\"\u0000-\u001F\u2028\u2029]/g;
			return function stringify(value) {
				if (value == null) {
					return "null";
				} else if (typeof value === "number") {
					return isFinite(value) ? value.toString() : "null";
				} else if (typeof value === "boolean") {
					return value.toString();
				} else if (typeof value === "object") {
					if (typeof value.toJSON === "function") {
						return stringify(value.toJSON());
					} else if (isArray(value)) {
						var res = "[";
						for (var i = 0; i < value.length; i++)
							res += (i ? ", " : "") + stringify(value[i]);
						return res + "]";
					} else if (toString.call(value) === "[object Object]") {
						var tmp = [];
						for (var k in value) {
							if (value.hasOwnProperty(k))
								tmp.push(stringify(k) + ": " + stringify(value[k]));
						}
						return "{" + tmp.join(", ") + "}";
					}
				}
				return "\"" + value.toString().replace(escRE, escFunc) + "\"";
			};
		})()
	},
	ajax: (function () {
		function createXHR() {
			const xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
			return xhr;
		}

		return function ajax(options) {
			var xhr = createXHR();

			if(!options.success){
				options.success = function(){};
			}

			if(!options.error){
				options.error = function(message){
					throw message;
				};
			}

			//判断请求方式
			if (options.method.toLowerCase() === "get") {
				// options.data = JSON.stringify(options.data)
				// 如果是get请求则将url加在后面，并且需要根据是否存在问好和&来处理
				options.url += options.url.indexOf("?") == -1 ? "?" + options.data : "&" + options.data;
				//options.url += "?"+options.data;
			}
			//同步
			if (options.async === false) {
				callback();
			}

			try{
				xhr.open(options.method, options.url, options.async);
			}catch (e){
				//IE89 不支持跨域请求
				xhr = new window.XDomainRequest();
				xhr.open(options.method, options.url);

			}

			//异步
			if (options.async === true) {
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
						callback();
					}
				};
			}
			//Safari 带上凭证报错: Cannot use wildcard in Access-Control-Allow-Origin when credentials flag is true.
			if(options.withCredentials){
				xhr.withCredentials = options.withCredentials;
			}


			if (options.method.toLowerCase() === "post") {
				//IE9不支持此方法
				xhr.setRequestHeader && xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
				xhr.send(options.data);
			} else {
				xhr.send(null);
			}

			function callback() {
				if (xhr.status == 200) {  //判断http的交互是否成功，200表示成功
					options.success(xhr.responseText);//回调传递参数
				} else {
					options.error("请求错误");
				}
			}
		};
	})(),

	on: function (element, type, callback) {
		if (element.addEventListener) {
			if (type.slice(0, 2) === "on") // 以 "on" 开头，不需要，则去掉
				type = type.slice(2);
			element.addEventListener(type, callback,true);
		} else {
			if (type.slice(0, 2) !== "on") // 没有以 "on" 开头，需要，则加上
				type = "on" + type;
			element.attachEvent(type, callback);
		}
	},
	closest:function(element,selector){
		if (window.Element && !Element.prototype.closest) {
			if(!element) return null;
			try{
				var matches = (element.document || element.ownerDocument).querySelectorAll(selector), i;
				do {
					i = matches.length;
					while (--i >= 0 && matches.item(i) !== element) {}
				} while ((i < 0) && (element = element.parentElement));
			}catch(e){
				element = null;
			}

			return element;
		}

		return element.closest(selector);
	}
};


//Object.create
if (typeof Object.create !== "function") {
	Object.create = function (proto, propertiesObject) {
		if (typeof proto !== "object" && typeof proto !== "function") {
			throw new TypeError("Object prototype may only be an Object: " + proto);
		} else if (proto === null) {
			throw new Error("This browser's implementation of Object.create is a shim and doesn't support 'null' as the first argument.");
		}

		if (typeof propertiesObject != "undefined") {
			throw new Error("This browser's implementation of Object.create is a shim and doesn't support a second argument.");
		}

		function F() {}
		F.prototype = proto;

		return new F();
	};
}

//Object.assign polyfill
// All credits go to the contributers on MDN
// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != "function") {
	Object.assign = function(target, varArgs) { // .length of function is 2
		"use strict";
		if (target == null) { // TypeError if undefined or null
			throw new TypeError("Cannot convert undefined or null to object");
		}

		var to = Object(target);

		for (var index = 1; index < arguments.length; index++) {
			var nextSource = arguments[index];

			if (nextSource != null) { // Skip over if undefined or null
				for (var nextKey in nextSource) {
					// Avoid bugs when hasOwnProperty is shadowed
					if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
		}
		return to;
	};
}
